import { withFormik } from 'formik'
import * as Yup from 'yup'

import user from 'legacy/components/User/User'

import LoginDialogInner from './LoginDialogInner'

export const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    email: Yup.string().email('Invalid email address').required('Email is required'),
    password: Yup.string().min(8).required('Password is required'),
  }),

  mapPropsToValues: () => ({
    email: '',
    password: '',
  }),

  handleSubmit: async (values, { props, setErrors }) => {
    let { redirect, onAuthChange } = props
    await user.getAuth(values.email, values.password, setErrors, redirect, onAuthChange)
  },
})

export default formikEnhancer(LoginDialogInner)
